import { AxiosResponse } from 'axios';

import { Lines, ProductCounts } from '../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostPagination extends ResponseREST {
	data: Array<Lines>;
}

export const postPagination = async (
	url: string,
	body: Pick<ProductCounts, 'scheduleName'>,
): Promise<ResponseSuccessPostPagination> => {
	return axiosInstance
		.post(`${url}`, body)
		.then((res: AxiosResponse<ResponseSuccessPostPagination>) => res.data)
		.catch((err) => err);
};
